import {Text} from "../text/index.js";
import {CardContent} from "./CardContent.jsx";
import {ContentWrapper} from "./styles.js";

export const Content = ({
  formatName,
  postTitle,
  themeSlug,
  date,
  designType,
  isImg,
  themeText,
  themeColor,
}) => {
  return (
    <ContentWrapper styles={{justifyContent: isImg ? "space-between" : "center"}}>
      <CardContent
        type={formatName}
        date={date}
        title={postTitle}
        designType={designType}
      />

      {themeText?.length && (
        <div
          style={{
            position: "absolute",
            bottom: 21,
          }}
        >
          {/*<Link styles={{whiteSpace: "normal"}} to={`/category/${themeSlug}`}>*/}
          <Text
            type={"tag"}
            styles={{color: themeColor || (designType === "blue" ? "#1E91D6" : "black")}}
          >
            {themeText}
          </Text>
          {/*</Link>*/}
        </div>
      )}
    </ContentWrapper>
  );
};
